"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = cancelable;
function cancelable(originalPromise) {
  var isCancelled = false;
  var newPromise = new Promise(function (resolve, reject) {
    originalPromise.then(function (val) {
      if (!isCancelled) {
        resolve(val);
      }
    }, function (err) {
      if (!isCancelled) {
        reject(err);
      }
    });
  });
  newPromise.cancel = function () {
    isCancelled = true;
  };
  return newPromise;
}
//# sourceMappingURL=cancelable.js.map